import moment from 'moment';

/**
 * Convert the string that the Meridian DatePicker component returns into
 * a javascript Date object
 */
export const datePickerStringToDateObj = (dateStr: string): Date => {
  // "dateStr" is empty when going through the "Alternate Placements" flow, when the
  // placement's end date prior to this flow was 3000-02-02. This only occurs for
  // sites not part of the DH pilot.
  const INDEFINITE_RESTRICTIONS_DATE = '3000-02-02';
  dateStr = dateStr === '' ? INDEFINITE_RESTRICTIONS_DATE : dateStr;
  return moment(dateStr).toDate();
};

/** Get user's current timezone in short form (eg. PDT, CST) */
export const getTzShort = (): string => {
  const tzNmaePart = new Intl.DateTimeFormat(undefined, { timeZoneName: 'short' })
    .formatToParts(new Date())
    .find((part) => part.type === 'timeZoneName');

  return tzNmaePart?.value || '';
};
